import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { ImageMask } from "component/micro/design/ImageMask"
import { FontIcon } from "component/w24/component/FontIcon"
import { EColors, EFonts, EVariables } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  icon: IconDefinition
  title: string
  description: string
  className?: string
}

export const BlackIconBox = (props: Props): JSX.Element => {
  const isWide = useIsWide()

  return (
    <S_BlackIconBox className={props.className}>
      {isWide && (
        <S_Left>
          <S_Icon>
            <FontIcon icon={props.icon} iconSize="36px" color={EColors.WHITE} />
          </S_Icon>
        </S_Left>
      )}
      <S_Right>
        {!isWide && (
          <S_Icon>
            <FontIcon
              icon={props.icon}
              iconSize={"22px"}
              color={EColors.WHITE}
            />
          </S_Icon>
        )}
        <S_Title>{props.title}</S_Title>
        <S_Description>{props.description}</S_Description>
      </S_Right>
      <ImageMask
        randomizePosition={true}
        image="contour"
        repeat={true}
        degress={140}
        finalOpacity={0.5}
        step={10}
        positionX={"4px"}
        positionY={"274px"}
      />
    </S_BlackIconBox>
  )
}

const S_BlackIconBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 48px;
  padding: 25px;
  border-radius: ${EVariables.Radius2};
  background-color: ${EColors.DARK};
  width: 100%;
  position: relative;
  @media only screen and (min-width: 1260px) {
    padding: 37px 42px;
    height: 171px;
  }
`

const S_Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const S_Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const S_Icon = styled.div``

const S_Title = styled.div`
  color: ${EColors.WHITE};
  font-family: ${EFonts.Bold};
  font-size: 18px;
  margin: 18px 0 12px 0;
  @media only screen and (min-width: 1260px) {
    font-size: 25px;
    margin: 0px 0 15px 0;
  }
`

const S_Description = styled.div`
  color: ${EColors.WHITE};
  font-family: ${EFonts.Medium2};
  font-size: 15px;
  line-height: 28px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    line-height: 37px;
  }
`
